/* show.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbYbGa%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A30rem)%7B._2rTNeWDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A48rem)%7B._2UeR8bDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._0THHewDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A90rem)%7B._1hlSbsDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A110.5rem)%7B._4pVFIkDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20not%20all%20and%20(min-width%3A30rem)%7B._3PnjIVDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20not%20all%20and%20(min-width%3A48rem)%7B._1U2uuEDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20not%20all%20and%20(min-width%3A64rem)%7B._3RxhahDHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20not%20all%20and%20(min-width%3A90rem)%7B._1q55U0DHe6%7Bdisplay%3Arevert%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20not%20all%20and%20(min-width%3A110.5rem)%7B._2HqVMBDHe6%7Bdisplay%3Arevert%7D%7D");
import { type JSX, type ReactNode } from 'react';
import { type BasePrimitiveProps } from '../components/types';
import type { Breakpoint, ComponentAs } from './types';
const styles = {
  default: "_3iDTPbYbGa",
  'above.xs': "_2rTNeWDHe6",
  'above.sm': "_2UeR8bDHe6",
  'above.md': "_0THHewDHe6",
  'above.lg': "_1hlSbsDHe6",
  'above.xl': "_4pVFIkDHe6",
  'below.xs': "_3PnjIVDHe6",
  'below.sm': "_1U2uuEDHe6",
  'below.md': "_3RxhahDHe6",
  'below.lg': "_1q55U0DHe6",
  'below.xl': "_2HqVMBDHe6"
};
type ResponsiveShowProps = {
  as?: ComponentAs;
  children: ReactNode;
} & ({
  above?: never;
  /**
   * Apply CSS to show this specifically **below** this breakpoint.
   * The smallest breakpoint is not included as it would never be shown and this would not be performant.
   *
   * @important do not mix `above` and `below` (TypeScript should prevent this).
   */
  below: Exclude<Breakpoint, 'xxs'>;
} | {
  /**
   * Apply CSS to show this specifically **above** this breakpoint.
   * The smallest breakpoint is not included as it would always be shown and this would not be performant.
   *
   * @important do not mix `above` and `below` (TypeScript should prevent this).
   */
  above: Exclude<Breakpoint, 'xxs'>;
  below?: never;
}) & Pick<BasePrimitiveProps, 'xcss'>;

/**
 * Shows the content at a given breakpoint.  By default, content is hidden.  The primary use case is for visual presentation.
 * Mix `<Show above="md">` with `<Hide above="md">` to achieve content that shifts at a breakpoint.
 *
 * Please note:
 * - This only uses `display: none` and `display: revert` to show/hide, it does not skip rendering of children trees.
 * - As this is rendered at all times, there is little performance savings here (just that this is not painted).
 */
export const Show = ({
  above,
  below,
  children,
  as: AsElement = 'div',
  xcss
}: ResponsiveShowProps): JSX.Element => {
  return <AsElement className={ax([styles.default, above && styles[`above.${above}`], below && styles[`below.${below}`], xcss])}>
			{children}
		</AsElement>;
};